import LocationView from './components/Views/LocationView/LocationView';
import ServiceView from './components/Views/ServiceView/ServiceView';

const applyViews = (config) => {
  config.views.contentTypesViews = {
    Location: LocationView,
    Service: ServiceView,
  };
  return config;
};

export default applyViews;
